import { Component } from 'react';
import type { ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { failed: boolean };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error('Form crashed:', error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div role="alert" className="border border-primary-200 p-6 text-sm text-foreground-700">
          <p>Something went wrong with the form.</p>
          <button
            type="button"
            onClick={() => this.setState({ failed: false })}
            className="cursor-target mt-4 cursor-pointer whitespace-nowrap border-b border-primary-500 pb-1 text-primary-600"
          >
            Reload form
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}